import { getEnvVar } from '../context/AuthContext'

const BASE_URL = getEnvVar('REACT_APP_REPORT_API_BASE_URL');

export const indirizziFetch = {
  // Report (generic — get/update funziona per tutti i tipi di report)
  GET_REPORTS: `${BASE_URL}/api/v1/reports`, // GET legacy non-filtrato (usare gli specializzati sotto)
  REPORT_BY_ID: (reportId: string) => `${BASE_URL}/api/v1/reports/${reportId}`, // Per GET (singolo) e PATCH (aggiornamento)

  // Best Execution: endpoint specializzati (lista + creazione + validate + ingest + ranking)
  GET_BE_REPORTS: `${BASE_URL}/api/v1/reports/best_execution`, // GET lista BE filtrata server-side
  CREATE_REPORT: `${BASE_URL}/api/v1/reports/best_execution`, // POST crea report BE
  BE_REPORT_BY_ID: (reportId: string) => `${BASE_URL}/api/v1/reports/best_execution/${reportId}`,
  VALIDATE_REPORT: `${BASE_URL}/api/v1/reports/best_execution/validate`, // POST validate prerequisites BE
  INDICIZZA_REPORT: `${BASE_URL}/api/v1/reports/best_execution/ingest`, // POST indicizzazione BE
  /** POST multipart: registra i bytes e crea il link in una chiamata sola (sostituisce /sources + /documents). */
  BE_REGISTER_SOURCE: `${BASE_URL}/api/v1/reports/best_execution/sources`,
  /** POST: ri-scarica le fonti remote e le confronta con quelle registrate. Risponde 202. */
  BE_CHECK_SOURCES: `${BASE_URL}/api/v1/reports/best_execution/check-sources`,
  /** POST: decide su una fonte cambiata — `keep` oppure `switch`. */
  BE_RESOLVE_SOURCE: (sourceId: string) =>
    `${BASE_URL}/api/v1/reports/best_execution/sources/${sourceId}/resolve`,

  // Conduct Risk: endpoint specializzati
  GET_CR_REPORTS: `${BASE_URL}/api/v1/reports/conduct_risk`, // GET lista CR filtrata server-side
  CREATE_CR_REPORT: `${BASE_URL}/api/v1/reports/conduct_risk`, // POST crea report CR
  CR_REPORT_BY_ID: (reportId: string) => `${BASE_URL}/api/v1/reports/conduct_risk/${reportId}`,
  UPLOAD_CR_SOURCE: (reportId: string) => `${BASE_URL}/api/v1/reports/conduct_risk/${reportId}/sources/upload`,
  LIST_CR_SOURCES: (reportId: string) => `${BASE_URL}/api/v1/reports/conduct_risk/${reportId}/sources`,
  UNLINK_CR_SOURCE: (reportId: string, linkId: string) => `${BASE_URL}/api/v1/reports/conduct_risk/${reportId}/sources/${linkId}`,
  DOWNLOAD_CR_SOURCE: (reportId: string, linkId: string) => `${BASE_URL}/api/v1/reports/conduct_risk/${reportId}/sources/${linkId}/download`,
  /**
   * GET: bytes di una fonte del catalogo, senza scoping sul report.
   * E' la via per scaricare una fonte Best Execution: la sua `uri` punta
   * all'object store (gs://...) e non e' apribile dal browser.
   */
  DOWNLOAD_SOURCE: (sourceId: string) => `${BASE_URL}/api/v1/sources/${sourceId}/download`,
  VALIDATE_CR_REPORT: (reportId: string) => `${BASE_URL}/api/v1/reports/conduct_risk/${reportId}/validate`,
  START_CR_REPORT: (reportId: string) => `${BASE_URL}/api/v1/reports/conduct_risk/${reportId}/start`,
  /** Export XLSX di un driver CR (Driver02, Driver04, Driver06 al momento). */
  EXPORT_CR_DRIVER_XLSX: (reportId: string, componentKind: string) =>
    `${BASE_URL}/api/v1/reports/conduct_risk/${reportId}/drivers/${componentKind}/export/xlsx`,
  /** Tabella di aggregazione evidenze investigation. */
  CR_INVESTIGATION_SUMMARY: (reportId: string) =>
    `${BASE_URL}/api/v1/reports/conduct_risk/${reportId}/investigation-summary`,
  /** Export XLSX della tabella di Investigation Summary. */
  EXPORT_CR_INVESTIGATION_SUMMARY_XLSX: (reportId: string) =>
    `${BASE_URL}/api/v1/reports/conduct_risk/${reportId}/investigation-summary/export/xlsx`,

  // Driver/Scenario scores e ranking (BE-only)
  DRIVER_SCORES: (reportId: string) => `${BASE_URL}/api/v1/reports/best_execution/${reportId}/driver_scores`,
  SCENARIO_SCORES: (reportId: string) => `${BASE_URL}/api/v1/reports/best_execution/${reportId}/scenario_scores`,
  FINAL_RANKING: (reportId: string) => `${BASE_URL}/api/v1/reports/best_execution/${reportId}/final_rankings`,
  SCENARI_WEIGHTS: (reportId: string) => `${BASE_URL}/api/v1/reports/best_execution/${reportId}/scenario_weights`,

  // files (generic)
  FILE_LATEST: (reportId: string) => `${BASE_URL}/api/v1/reports/${reportId}/files/latest`,
  REPORT_FILES: (reportId: string) => `${BASE_URL}/api/v1/reports/${reportId}/files`,
  
  // Componenti del Report
  COMPONENTS_BY_REPORT_ID: (reportId: string) => `${BASE_URL}/api/v1/reports/${reportId}/components`,
  COMPONENT_BY_ID: (reportId: string, componentId: string) => `${BASE_URL}/api/v1/reports/${reportId}/components/${componentId}`,

  // Elementi di un Componente
  ELEMENTS_BY_COMPONENT_ID: (reportId: string, componentId: string) =>
    `${BASE_URL}/api/v1/reports/${reportId}/components/${componentId}/elements`,
  ELEMENT_BY_ID: (reportId: string, componentId: string, elementId: string) =>
    `${BASE_URL}/api/v1/reports/${reportId}/components/${componentId}/elements/${elementId}`,

  /** GET: come il valore di un elemento e' stato prodotto, dal piu' recente. */
  ELEMENT_GENERATIONS: (reportId: string, componentId: string, elementId: string) =>
    `${BASE_URL}/api/v1/reports/${reportId}/components/${componentId}/elements/${elementId}/generations`,

  // Modifica e validazione di un Elemento
  EDIT_ELEMENT: (reportId: string, componentId: string, elementId: string) =>
    `${BASE_URL}/api/v1/reports/${reportId}/components/${componentId}/elements/${elementId}/edit`,
  VALIDATE_ELEMENT: (reportId: string, componentId: string, elementId: string) =>
    `${BASE_URL}/api/v1/reports/${reportId}/components/${componentId}/elements/${elementId}/validate`,
  
  // Sorgenti di un Elemento
  SOURCES_BY_ELEMENT_ID: (reportId: string, componentId: string, elementId: string) =>
    `${BASE_URL}/api/v1/reports/${reportId}/components/${componentId}/elements/${elementId}/sources`,
  SOURCE_BY_ID: (reportId: string, componentId: string, elementId: string, sourceId: string) =>
    `${BASE_URL}/api/v1/reports/${reportId}/components/${componentId}/elements/${elementId}/sources/${sourceId}`,

  GET_TEMPLATES: `${BASE_URL}/api/v1/templates`,
  TEMPLATE_BY_ID: (templateId: string) => `${BASE_URL}/api/v1/templates/${templateId}`,

  // Venues
  LIST_VENUES: (skip = 0, limit = 100) =>
    `${BASE_URL}/api/v1/venues?skip=${skip}&limit=${limit}`,

  SEARCH_VENUES: (skip = 0, limit = 100) =>
    `${BASE_URL}/api/v1/venues/search?skip=${skip}&limit=${limit}`,
  // Events
  SEARCH_EVENTS: `${BASE_URL}/api/v1/events/search`,
  // Export DOCX
  EXPORT_DOCX: (reportId: string) => `${BASE_URL}/api/v1/reports/${reportId}/export/docx`,
  // Export XLSX
  EXPORT_XLSX: (reportId: string) => `${BASE_URL}/api/v1/reports/${reportId}/export/xlsx`,
  // Export componenti XLSX
  EXPORT_COMPONENT_XLSX : (reportId: string, componentId: string) =>
      `${BASE_URL}/api/v1/reports/${reportId}/components/${componentId}/export/xlsx`,
  // Approve Report
  APPROVE: (reportId: string) => `${BASE_URL}/api/v1/reports/${reportId}/approve`,
  // Complete Report
  COMPLETE: (reportId: string) => `${BASE_URL}/api/v1/reports/${reportId}/complete`,
  // Reopen Report
  REOPEN: (reportId: string) => `${BASE_URL}/api/v1/reports/${reportId}/reopen`,

//Bank
  GET_BANKS: `${BASE_URL}/api/v1/banks`, // Per GET (lista) 
  POST_bANKS: `${BASE_URL}/api/v1/banks/`,
  INITIALIZE_BANK_DOCUMENT_CLASSES: (bankId: string) =>`${BASE_URL}/api/v1/banks/${bankId}/document-classes/initialize`, // POST initialize document classes

  BANK_BY_ID: (bankId: string) => `${BASE_URL}/api/v1/banks/${bankId}`,
  DOCUMENT_BANK_BY_ID: (bankId: string) => `${BASE_URL}/api/v1/reports/best_execution/document-classes/bank/${bankId}`,
  UPDATE_BANK_ALIASES: (bankId: string) => `${BASE_URL}/api/v1/banks/${bankId}`,

// Document Sources
DOCUMENT_CLASS_SOURCES: (documentClassId: string) => `${BASE_URL}/api/v1/documents/document-class/${documentClassId}`, // GET sources by document class

// Crea sources — route generiche legacy: non conoscono la banca, quindi i bytes
// finiscono fuori dal layout per banca. Per il BE usare BE_REGISTER_SOURCE.
CREATE_SOURCES : `${BASE_URL}/api/v1/sources` ,
ADD_SOURCE_TO_DOCUMENT_CLASS: `${BASE_URL}/api/v1/documents`,

// Storico di una fonte (newest first, paginati con skip/limit)
SOURCE_CHECKS: (sourceId: string) => `${BASE_URL}/api/v1/sources/${sourceId}/checks`,
SOURCE_INGESTIONS: (sourceId: string) => `${BASE_URL}/api/v1/sources/${sourceId}/ingestions`,

// Document Classes — BE (nested sotto /reports/best_execution)
BE_DOCUMENT_CLASSES: `${BASE_URL}/api/v1/reports/best_execution/document-classes`,
BE_DOCUMENT_CLASSES_GENERAL: `${BASE_URL}/api/v1/reports/best_execution/document-classes/general`,
BE_DOCUMENT_CLASSES_BY_BANK: (bankId: string) => `${BASE_URL}/api/v1/reports/best_execution/document-classes/bank/${bankId}`,
BE_DOCUMENT_CLASS_BY_ID: (documentClassId: string) => `${BASE_URL}/api/v1/reports/best_execution/document-classes/${documentClassId}`,

// Document Classes — CR (nested sotto /reports/conduct_risk)
CR_DOCUMENT_CLASSES: `${BASE_URL}/api/v1/reports/conduct_risk/document-classes`,
CR_DOCUMENT_CLASS_BY_TYPE: (documentType: string) => `${BASE_URL}/api/v1/reports/conduct_risk/document-classes/by-type/${documentType}`,
CR_DOCUMENT_CLASS_BY_ID: (documentClassId: string) => `${BASE_URL}/api/v1/reports/conduct_risk/document-classes/${documentClassId}`,

DEACTIVATE_DOCUMENT: `${BASE_URL}/api/v1/documents`,

};
